const MemberSettleType = ['None','Wait','Normal','Free','Free absent']
const CourseCode = ["AMath","AP","Art","Camp","Chinese","Coding","CMath","Duplo","Debate","English","French","Java","Python","PS","RW","Scratch","Team","VexIQ","VRC","Wedo","Other","code"]
export {MemberSettleType,CourseCode}